export default {
    'pdf-content-media-content-files': `
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
        `,
    'pdf-content-media': `display: flex; align-items: center;`,
    'video-file': `
            position: relative;
            margin-bottom: 0.3125rem;
            width: 100% !important;
        `,
    'video-file > img': `
            width: 100% !important;
            background-color: rgba(255, 255, 255, 0.25);
        `,
    'pdf-content-media > img': `margin-right: 0.9375rem;`,
    'qr-position': `
            position: absolute;
            right: 1.75rem;
            bottom: 0.625rem;
            background: #fff;
        `,
    'pdf-content-media-qr > img': `
            width: 100px;
        `,
    'pdf-content-media-audio > img': `
            width: 2.9375rem;
            height: 2.5rem;
            object-fit: contain;
            margin-right: 0.9375rem;
        `,
    'file-size file-name': `
            font-family: open sans, sans-serif;
            font-size: 0.5rem;
            font-weight: 600;
            color: #000000;
            line-height: 1.1;
        `,
    'file-date file-type': `
            font-family: open sans, sans-serif;
            font-size: 0.5rem;
            font-weight: normal;
            color: #000000;
            line-height: 1.1;
        `,
    'pdf-content-media-desc': `
            word-break: break-all;
            flex: 1;
        `,
    'figcaption': `
            margin-top: .625rem;
            margin-bottom: .9375rem;
            opacity: .8;
            font-size: .9375rem;
            font-weight: 400;
            color: #3e3e3e;
            line-height: 1.33;
        `
};